import { render, staticRenderFns } from "./CrmUserPage.vue?vue&type=template&id=4aba9a7f&scoped=true&"
import script from "./CrmUserPage.vue?vue&type=script&lang=js&"
export * from "./CrmUserPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aba9a7f",
  null
  
)

export default component.exports